import { render } from "./WechatAuthView.vue?vue&type=template&id=7d0a3c0e&scoped=true&ts=true"
import script from "./WechatAuthView.vue?vue&type=script&lang=ts"
export * from "./WechatAuthView.vue?vue&type=script&lang=ts"

import "./WechatAuthView.vue?vue&type=style&index=0&id=7d0a3c0e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0a3c0e"]])

export default __exports__